import Hangman from "./hangman"
import getPuzzle from "./requests"

const puzzleEl = document.querySelector("#hangman-text");
const guessesEl = document.querySelector("#hangman-guesses");
let word1;

const render = () => {
  puzzleEl.innerHTML="";
  guessesEl.textContent = word1.statusMessage;

  word1.puzzle.split("").forEach((letter) => {
    const letterEl = document.createElement("span")
    letterEl.textContent = letter
    puzzleEl.appendChild(letterEl)
  }); 
};

const startGame = async () => {
  const puzzle = await getPuzzle("2");
  word1 = new Hangman(puzzle, 8);
  render();
};

document.querySelector("#reset").addEventListener("click", startGame);

startGame();

window.addEventListener("keypress", (e) => {
  const guess = String.fromCharCode(e.charCode);
  word1.makeGuess(guess);
  render();
});
